export enum TourType {
  IN_PERSON = 'In-person',
  VIRTUAL = 'Virtual',
  SELF_GUIDED = 'Self-guided',
}
